import React from 'react';
import ReactDOM from 'react-dom';
import store from './store';
import history from './shared/history';
import Root from './root';
import './assets/css/design-system.scss';
import './i18n';
import ErrorBoundaryWrapper from './shared/components/error-boundary-wrapper';
import { initializePosthog } from './shared/utils';

// Initialize PostHog before rendering so the root-level ErrorBoundaryWrapper
// can capture events even when errors occur during the initial render.
const posthogToken = process.env.REACT_APP_POSTHOG_TOKEN;
if (posthogToken) {
  initializePosthog(posthogToken);
}

declare global {
  interface Window {
    smartlook: any;
    fwcrm: any;
    Froged: any;
    Beacon: any;
    Headway: any;
    churnkey: any;
    HighAdvocacy: any;
    Rewardful: any;
    rewardful: any;
    intercomSettings: any;
    Intercom: any;
    profitwell: any;
    Paddle: any;
    Gleap: any;
    google: any;
    _cio: any;
    tolt_referral?: string;
  }
}

ReactDOM.render(
  <ErrorBoundaryWrapper>
    <Root store={store} history={history} />
  </ErrorBoundaryWrapper>,
  document.getElementById('root'),
);
